// "Cum se creează..." initiative steps become a Swiper carousel on mobile
// only — same technique as community-swiper.js (Swiper is
// instantiated/destroyed across the 767px breakpoint so the desktop
// sticky-cascade layout in _initiative-steps.scss is never touched).
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';

$(function () {
    const el = document.querySelector('[data-steps-swiper]');

    if (!el) {
        return;
    }

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    let swiper = null;

    const enable = () => {
        if (swiper) {
            return;
        }

        swiper = new Swiper(el, {
            modules: [Navigation, FreeMode],
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            navigation: {
                nextEl: '[data-steps-next]',
                prevEl: '[data-steps-prev]',
            },
        });
    };

    const disable = () => {
        if (!swiper) {
            return;
        }

        swiper.destroy(true, true);
        swiper = null;
    };

    const sync = () => (mediaQuery.matches ? enable() : disable());

    sync();
    mediaQuery.addEventListener('change', sync);
});
